module.exports = __webpack_public_path__ + "static/media/faith.3857ef48.svg";